module.exports = "/packs/onbording_02-11e89769d77cd4f49a48b8dbfa2c920c.jpg";